<div *ngIf="!isAdminRoute() && isUserActive()">
  <div class="quarter-container">
    <mat-form-field class="top" *ngIf="isUserActive()">
      <mat-label>Org</mat-label>
      <mat-select [(value)]="selectedOQContext.org" (opened)="setViewToSelected()" #orgSelector>
        <mat-option *ngFor="let org of organizations" (click)="selectedOrgChanged(org)" (keydown.enter)="selectedOrgChanged(org)" [value]="org">
          {{org.orgCode}} - {{org.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="middle" *ngIf="isUserActive()">
      <mat-label>Current Quarter</mat-label>
      <mat-select [(value)]="selectedOQContext.qtr">
        <mat-option *ngFor="let quarter of quarters" (click)="selectedQuarterChanged(quarter)" (keydown.enter)="selectedQuarterChanged(quarter)" [value]=quarter>
            {{quarter.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="bottom" *ngIf="isUserActive()">
      <mat-label>Currency</mat-label>
      <input matInput readonly value="{{ selectedOQContext.org?.defaultCurrency}}" />
    </mat-form-field>

  </div>
</div>
